import { render, staticRenderFns } from "./VersionAlignmentSelector.vue?vue&type=template&id=ec32cabc&scoped=true&"
import script from "./VersionAlignmentSelector.vue?vue&type=script&lang=js&"
export * from "./VersionAlignmentSelector.vue?vue&type=script&lang=js&"
import style0 from "./VersionAlignmentSelector.vue?vue&type=style&index=0&id=ec32cabc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec32cabc",
  null
  
)

component.options.__file = "VersionAlignmentSelector.vue"
export default component.exports